import { Avatar, Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MySideBar from "./SideBar";
import "./styles/main-layout.scss";
import { Outlet } from "react-router-dom";
import {
  getFunctionsByRole,
  getProfile,
  getTinhs,
  getAllDms,
  getKinhTuyenTruc
} from "./services/apis/danhmuc-service";
import {
  commonReducerSelector,
  tableSelector,
  userSelector
} from "./redux/selector";
import tableReducer from "./redux/slice/TableSile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import {
  AppBar,
  IconButton,
  Tooltip,
  Typography,
  ListItemIcon,
  Menu,
  MenuItem
} from "@mui/material";
import "./styles/appbar.scss";
import { userManager } from "./oidc";
import { useNavigate } from "react-router-dom";
import Logout from "@mui/icons-material/Logout";
import image_playlist from "./assets/images/Playlist.png";
import image_playlist_open from "./assets/images/Playlist_open.png";
import logo from "./assets/images/logoCaChinhBong.png";

import Api, { setCurrentUser } from "./api2";
import { setCurrentUser2 } from "./api_danhmuc";
import { Constant } from "./constants/constant";
import { Info } from "@mui/icons-material";
import userReducer from "./redux/slice/userSlice";
import { isEmpty } from "lodash";
import sanXuat from "./assets/images/sanXuat.png";
import cheBien from "./assets/images/cheBien.png";
import phanPhoi from "./assets/images/phanPhoi.png";

export function MyAppBar(props) {
  const commonReducer = useSelector(commonReducerSelector);
  const profile = commonReducer.profile.data;
  const [anchorEl, setAnchorEl] = React.useState(null); //drop menu tài khoản
  const isMenuOpen = Boolean(anchorEl); //drop menu tài khoản
  const menuId = "primary-search-account-menu"; //id drop menu tài khoản
  const [anchorElApplication, setAnchorElApplication] = React.useState(null);
  const isMenuOpenApplication = Boolean(anchorElApplication);
  const dispatch = useDispatch();
  let navigate = useNavigate(); //chuyển trang

  const handleDrawerOpen = () => {
    props.handleDrawerOpen();
    dispatch(tableReducer.actions.autofit());
  };

  const Logouts = value => {
    setAnchorEl(null);
    navigate("/");
  };
  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenuOpenApplication = event => {
    setAnchorElApplication(event.currentTarget);
  };

  const handleMenuCloseApplication = () => {
    setAnchorElApplication(null);
  };
  const handlenguoidung = () => {
    localStorage.setItem("CSCORE_LINK", `${window.location.pathname}`);
  };

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  function stringAvatar(name) {
    const nameArr = name?.split(" ");
    const first = nameArr?.[0]?.[0] || "U";
    const second = nameArr?.[1]?.[0] || "D";
    return {
      sx: {
        bgcolor: stringToColor(name)
      },
      children: `${first}${second}`
    };
  }

  useEffect(() => {
    const hasLoggedIn = localStorage.getItem("hasLoggedIn");
    // if (!hasLoggedIn) {
    //     new Api()
    //         .PostLoginNhatKyHeThong({})
    //         .then((res) => {
    //             if (res.code === 200){
    //                 localStorage.setItem('hasLoggedIn', true);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         })
    // }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("hasLoggedIn");
    localStorage.removeItem("accessToken");
    dispatch(userReducer.actions.clearUserInfo());
    navigate('');
    // new Api()
    //     .PostLogoutNhatKyHeThong({})
    //     .then((res) => {
    //     })
    //     .catch((err) => {
    //         console.log(err);
    //     })
  };

  // menu thông tin tài khoản
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      disableScrollLock={true}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          padding: "0.5rem",
          ".css-6hp17o-MuiList-root-MuiMenu-list": {
            padding: "0px 0px"
          },
          ".css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root": {
            marginBottom: "8px"
          },
          ".css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root:hover": {
            backgroundColor: "#f0f2f5",
            borderRadius: "0.375rem",
            ".thongtintaikhoan__icon": {
              color: "#344767"
            },
            ".thongtintaikhoan__text": {
              color: "#344767"
            }
          }
        }
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* {Boolean(profile?.idDoanhNghiep) && (
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`doanhnghiep/infor/${profile.idDoanhNghiep}`);
          }}
        >
          <ListItemIcon>
            <Info className="thongtintaikhoan__icon" fontSize="small" />
          </ListItemIcon>
          <p className="thongtintaikhoan__text">Thông tin doanh nghiệp</p>
        </MenuItem>
      )} */}
      <MenuItem
        onClick={() => {
          setAnchorEl(null);
          navigate(`thongtintaikhoan`);
        }}
      >
        <ListItemIcon>
          <Info className="thongtintaikhoan__icon" fontSize="small" />
        </ListItemIcon>
        <p className="thongtintaikhoan__text">Thông tin tài khoản</p>
      </MenuItem>
      {Boolean(profile?.idCoSoSanXuat) && (
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`thongtincososanxuat`);
          }}
        >
          <ListItemIcon>
            <img style={{ width: 20, height: 20 }} src={sanXuat}></img>
          </ListItemIcon>
          <p className="thongtintaikhoan__text">Thông tin cơ sở sản xuất</p>
        </MenuItem>
      )}
      {Boolean(profile?.idCoSoCheBien) && (
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`thongtincosochebien`);
          }}
        >
          <ListItemIcon>
            <img style={{ width: 20, height: 20 }} src={cheBien}></img>
          </ListItemIcon>
          <p className="thongtintaikhoan__text">Thông tin cơ sở chế biến</p>
        </MenuItem>
      )}
      {Boolean(profile?.idCoSoPhanPhoi) && (
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`thongtincosophanphoi`);
          }}
        >
          <ListItemIcon>
            <img style={{ width: 20, height: 20 }} src={phanPhoi}></img>
          </ListItemIcon>
          <p className="thongtintaikhoan__text">Thông tin cơ sở phân phối</p>
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          // userManager.signoutRedirect();
          handleLogout();
        }}
      >
        <ListItemIcon>
          <Logout className="thongtintaikhoan__icon" fontSize="small" />
        </ListItemIcon>
        <p className="thongtintaikhoan__text">Đăng xuất</p>
      </MenuItem>
    </Menu>
  );
  return (
    <div className="my-appbar">
      <AppBar
        style={{
          // transition: 'all 0.3s ease-in-out',
          boxShadow: "none",
          background: "#f6f8fc",
          borderBottom: "1px solid #dfdfdf"
        }}
      >
        <div className="my-appbar__toolbar">
          <div className="my-appbar__toolbar__left">
            <IconButton
              style={{ padding: "5px 5px 5px 0px" }}
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
            >
              {props.openDraw ? (
                <img src={image_playlist} />
              ) : (
                <img src={image_playlist_open} />
              )}
            </IconButton>
            <div
              style={{
                marginLeft: 5,
                display: "flex",
                paddingRight: "15px",
                alignItems: "center",
                cursor: "pointer"
              }}
              onClick={() => navigate("trangchu")}
            >
              <div style={{ width: "54px", height: "54px" }}>
                <img src={logo} style={{ width: "100%", height: "auto" }} />
              </div>
              <div style={{ paddingLeft: "10px" }}>
                <div className="title-tc">{Constant.TITLE_TO_CHUC}</div>
                <div className="title-pm">{Constant.TITLE_PHAN_MEM}</div>
              </div>
            </div>
            {/* <Paper
                            // component="form"
                            sx={{ p: '2px 4px', background: '#f0f0f0', height: '40px', boxShadow: 'none', display: 'flex', alignItems: 'center', width: 600, borderRadius: 4 }}
                        >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Nhập từ khóa cần tìm"
                                inputProps={{
                                    onKeyDown: (e) => {
                                        if (e.key === 'Enter') {
                                            console.log(e.target.value);
                                        }
                                    },
                                }}
                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <img src={image_search} />
                            </IconButton>
                        </Paper> */}
          </div>
          <div className="my-appbar__toolbar__right">
            {/* <div style={{ paddingRight: 30, display: 'flex' }}>
                            <div className="icon-noti">
                                <img src={image_notification} />
                            </div>
                            <div className="icon-noti">
                                <img src={image_question} />
                            </div>
                            <div className="icon-noti">
                                <img src={image_Headphones} />
                            </div>
                        </div> */}
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center"
              }}
              onClick={handleProfileMenuOpen}
              className="myappbar__person"
            >
              <Tooltip title="Thông tin tài khoản">
                <Typography
                  style={{
                    cursor: "pointer",
                    color: "#000000",
                    fontSize: "15px",
                    fontWeight: "bold",
                    userSelect: "none"
                  }}
                  className="name-account"
                >
                  {profile && profile.fullName}
                </Typography>
                {/* <Typography style={{ cursor: 'pointer', textAlign: 'end' }} className="name-account">
                                    {profile && profile.userName}
                                </Typography> */}
              </Tooltip>
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  marginLeft: "5px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <Avatar
                  {...stringAvatar(profile?.fullName || "Not Found")}
                  style={{ width: "30px", height: "30px", fontSize: "13px" }}
                />
              </div>
            </div>
            {renderMenu}
          </div>
        </div>
      </AppBar>
    </div>
  );
}

//draw sidebar
// const drawerWidth = 350;
const drawerWidth = 300;
const openedMixin = theme => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: "200ms"
  }),
  overflowX: "hidden"
});
const closedMixin = theme => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: "200ms"
  }),
  overflowX: "hidden",
  width: `70px`,
  [theme.breakpoints.up("sm")]: {
    width: `70px`
  }
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  minHeight: "60px",
  padding: theme.spacing(0, 1)
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== "open"
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",

  boxSizing: "border-box",
  ".css-12i7wg6-MuiPaper-root-MuiDrawer-paper": {
    backgroundColor: "#f6f8fc",
    border: "none"
  },
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme)
  })
}));
//

export default function MainLayout(props) {
  const [openDraw, setOpenDraw] = useState(true); //thu gon page
  const [phanquyen, setPhanQuyen] = useState(true); //có quyền : true : không có quyền false
  const [defaultOpen, setDefaultOpen] = useState(false); // Khi không có trang chủ mặc định chọn hoặc mở 1 tính năng khác

  const [check_trangchu, setCheck_trangchu] = useState(false);
  const [link, setLink] = useState("/");
  //redux
  const commonReducer = useSelector(commonReducerSelector);
  const user = useSelector(userSelector);
  const tableselector = useSelector(tableSelector);
  const dispatch = useDispatch();
  //
  const navigate = useNavigate();
  useEffect(() => {
    if (!isEmpty(user)) {
      setCurrentUser(user); // first of all authenticated api
      setCurrentUser2(user);
      // dispatch(getProfile(user));
      dispatch(getProfile({user: user}));
      dispatch(getFunctionsByRole(user));
      props.setLoading(false)
      // dispatch(getTinhs(user));
      // dispatch(getAllDms(user));
      // dispatch(getKinhTuyenTruc({ user, cap: Constant.CAP_TRIEN_KHAI }));
    }
  }, [user]);

  useEffect(() => {
    if (link === "" || link === "/trangchu") {
      setCheck_trangchu(true);
    } else {
      setCheck_trangchu(false);
    }
  }, [link]);
  useEffect(() => {
    if (
      commonReducer.functions.data?.length > 0 &&
      commonReducer.functions.data?.[0]?.moduleCode !== "vanhanh_trangchu"
    ) {
      setDefaultOpen(true);
    }
  }, [commonReducer]);

  const handleDrawerOpen = () => {
    setOpenDraw(!openDraw);
    dispatch(tableReducer.actions.handleOpenDraw());
  };

  let phanquyenContent = null;
  
  if (phanquyen === true) {
    phanquyenContent = (
      <div
        className={check_trangchu ? "class-trangchu" : "class-chil"}
        style={{
          width:
            tableselector?.detail && openDraw
              ? "calc(100vw - 360px)"
              : tableselector?.detail &&
                openDraw === false &&
                "calc(100vw - 80px)"
        }}
      >
        <Outlet />
      </div>
    );
  }
  if (phanquyen === false && !defaultOpen) {
    phanquyenContent = (
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-404"></div>
          <h1>401</h1>
          <h2>BẠN KHÔNG CÓ QUYỀN TRUY CẬP</h2>
        </div>
      </div>
    );
  }
  
  return user && user.access_token ? (
    <div>
      {commonReducer.functions.loading !== "success" ||
      commonReducer.profile.loading !== "success" ? (
        <div className="flat">
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        </div>
      ) : (
        <div className="main-layout">
          <Box sx={{ display: "flex" }}>
            <MyAppBar handleDrawerOpen={handleDrawerOpen} openDraw={openDraw} />
            <Drawer variant="permanent" open={openDraw}>
              <DrawerHeader />
              <MySideBar
                openDraw={openDraw}
                handleDrawerOpen={handleDrawerOpen}
                setPhanQuyen={setPhanQuyen}
                setLink={setLink}
                defaultOpen={defaultOpen}
              />
            </Drawer>
            <div className="main-layout__body">
              <DrawerHeader style={{ minHeight: "47px" }} />
              <div className="main-layout__body__content">
                <div className="main-layout__body__content__detail">
                  <div
                    style={{
                      transition: "all 0.5s ease-in-out",
                      // width: tableselector?.detail && openDraw ? `calc(100vw - 850px)` : tableselector?.detail && openDraw === false ? `calc(100vw - 600px)` : openDraw ? 'calc(100vw - 360px)' : 'calc(100vw - 80px)',
                      width:
                        tableselector?.detail && openDraw
                          ? `calc(100vw - 850px)`
                          : tableselector?.detail && openDraw === false
                          ? `calc(100vw - 600px)`
                          : openDraw
                          ? "calc(100vw - 310px)"
                          : "calc(100vw - 80px)",
                      overflow: "auto",
                      // transition: tableselector?.detail && openDraw && "all 0.5s ease-in-out",
                      background: "#F6F8FC"
                    }}
                  >
                    {phanquyenContent}
                    <ToastContainer
                      position="bottom-right"
                      autoClose={500}
                      hideProgressBar={true}
                      closeOnClick
                      theme="colored"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      )
      }
    </div>
  ) : (
    ""
  );
}
